import React, { Component } from "react";
import { Link } from "react-router-dom";
import { connect } from "react-redux";
import Tooltip from "@material-ui/core/Tooltip";
import "./Sidebar.css";
import store from "../../../redux/store";
import ActiveMenuAction from "../../../redux/activeMenu/ActiveMenuAction";
import Utils from "../../../provider/Utils";
class EventSidebar extends Component {
  header = store.getState().header.header;
  profile = store.getState().appUserData.appUserData.appuser?.profile;
  menuList = store.getState().appUserData.appUserData.appuser?.profile?.menus;
  planType = store.getState().appUserData.appUserData.planType?.type;

  constructor(props) {
    super(props);
    let activeChildMenu = store.getState().activeMenu.activeChildMenu;
    if (undefined === activeChildMenu || null === activeChildMenu) {
      activeChildMenu =
        (this.menuList && this.menuList.length) > 0
          ? Utils.getArrayElement(this.menuList, 0)?.id
          : -1;
    }
    this.handleClick = this.props.handleClick?.bind(this);
    this.state = {
      isOpen: true,
      isBillingActive: false,
      tokenPrice: "",
      sidebarMenu: this.menuList
        ?.filter((menu) => menu.menuid === "EventManagement")[0]
        ?.childMenus.sort((a, b) => a.displaysequence - b.displaysequence),
      childMenus: this.menuList
        ?.filter((menu) => menu.menuid === "EventManagement")[0]
        ?.childMenus.sort((a, b) => a.displaysequence - b.displaysequence),
      activeChildMenu: activeChildMenu,
    };
  }

  selectedChildMenu = (e, id, pageid) => {
    for (let i = 0; i < this.state.sidebarMenu.length; i++) {
      if (this.state.sidebarMenu[i].id === id) {
        store.dispatch(ActiveMenuAction.setActiveChildMenu(pageid));
        this.setState({ activeChildMenu: pageid, isBillingActive: false });
      }
    }

    for (
      let i = 0;
      this.state.sidebarMenu && i < this.state.sidebarMenu.length;
      i++
    ) {
      if (this.activeChildMenu === pageid) {
        store.dispatch(ActiveMenuAction.setActiveChildMenu(pageid));
        this.setState({ activeChildMenu: pageid });
        this.state.sidebarMenu[i].isActive = true;
      } else {
        if (this.state.sidebarMenu[i].id === id) {
          store.dispatch(ActiveMenuAction.setActiveChildMenu(pageid));
          this.setState({ activeChildMenu: pageid });
          this.state.sidebarMenu[i].isActive = true;
        } else {
          this.state.sidebarMenu[i].isActive = false;
        }
      }
    }
  };

  selectedBillingChildMenu = (e) => {
    store.dispatch(ActiveMenuAction.setActiveChildMenu("/eventBillingInfo"));
    this.setState({ isBillingActive: !this.state.isBillingActive });
  };

  toggleSidebar = () => {
    this.setState({ isOpen: !this.state.isOpen });
    this.handleClick(!this.state.isOpen);

    if (window.innerWidth > 1199) {
      return;
    }

    let appClasses = document.getElementById("app").classList;
    let overlayClasses = document.getElementById("overlay").classList;

    if (appClasses.contains("sidebar-menu-extended")) {
      appClasses.remove("sidebar-menu-extended");
      overlayClasses.remove("overlay-active");
    } else {
      appClasses.add("sidebar-menu-extended");
      overlayClasses.add("overlay-active");
    }
  };

  isEmpty(obj) {
    for (const key in obj) {
      if (obj.hasOwnProperty(key)) return false;
    }
    return true;
  }

  render() {
    const isOnetime = Utils.equalsIgnoreCase(this.planType, "Onetime");
    const isAdmin = Utils.equalsIgnoreCase(this.profile?.name, "Admin");
    let activeChildMenu = store.getState().activeMenu.activeChildMenu;
    for (
      let i = 0;
      this.state.sidebarMenu && i < this.state.sidebarMenu.length;
      i++
    ) {
      if (this.state.sidebarMenu[i].pageid === activeChildMenu) {
        this.state.sidebarMenu[i].isActive = true;
      } else {
        this.state.sidebarMenu[i].isActive = false;
      }
    }
    return (
      <div>
        <aside
          id="layout-menu"
          className={
            this.state.isOpen
              ? "layout-menu menu-vertical eventMenu bg-menu-theme eventSidebar"
              : "layout-menu menu-vertical eventMenu bg-menu-theme eventSidenavClosed"
          }
          style={{ height: "100%", backgroundColor: "#1B7D89", zIndex: "1200" }}
        >
          <div className="menu-inner-shadow" />
          <ul className="menu-inner py-1">
            <div className="app-brand demo">
              <div
                className="layout-menu-toggle menu-link text-large ms-auto sidebar-toggle"
                style={{ left: this.state.isOpen ? "12rem" : "5.1rem" }}
                onClick={this.toggleSidebar}
              >
                <Tooltip
                  title={this.state.isOpen ? "Collapse" : "Expand"}
                  classes={{ popper: "custom-tooltip" }}
                >
                  <i
                    className="bx bx-chevron-left bx-sm align-middle z-1"
                    style={{
                      transform: this.state.isOpen
                        ? "rotateY(0deg)"
                        : "rotateY(180deg)",
                    }}
                  />
                </Tooltip>
              </div>
            </div>
            {this.state.childMenus?.map((m, key) => {
              if (!this.isEmpty(m)) {
                return m.isactive === true ? (
                  <Link
                    key={key}
                    to={m.pageid}
                    onClick={(e) => this.selectedChildMenu(e, m.id, m.pageid)}
                    className={
                      m.isActive === true ? "menu-item active" : "menu-item"
                    }
                    style={{ width: this.state.isOpen ? "210px" : "90px" }}
                  >
                    <div
                      className={
                        this.state.isOpen ? "openMenu-link menu-link me-2" : "menu-link"
                      }
                      style={{ color: "#fff" }}
                    >
                      {this.state.isOpen ? (
                        <>
                          <div
                            style={{
                              width: "35px",
                              display: "flex",
                              alignItems: "center",
                              justifyContent: "center",
                            }}
                          >
                            <i
                              className={`menu-icon tf-icons ${m.icon}`}
                              style={{
                                height: "22px",
                                textAlign: "center",
                                lineHeight: "22px",
                              }}
                            />
                          </div>
                          <div
                            className="link_text text-start"
                          >
                            {m.uiname}
                          </div>
                        </>
                      ) : (
                        <Tooltip
                          title={m.uiname}
                          classes={{ popper: "custom-tooltip" }}
                        >
                          <i
                            className={`menu-icon tf-icons ${m.icon}`}
                            style={{
                              height: "22px",
                              textAlign: "center",
                              lineHeight: "22px",
                            }}
                          />
                        </Tooltip>
                      )}
                    </div>
                  </Link>
                ) : (
                  <div></div>
                );
              }
            })}
            {/* {isOnetime && (this.header?.isAp || isAdmin) && (
              <Link
                to={"/eventBillingInfo"}
                onClick={(e) => this.selectedBillingChildMenu(e)}
                className={
                  this.state.isBillingActive === true
                    ? "menu-item active"
                    : "menu-item"
                }
                style={{ width: this.state.isOpen ? "210px" : "90px" }}
              >
                <div
                  className={
                    this.state.isOpen ? "openMenu-link menu-link me-2" : "menu-link"
                  }
                  style={{ color: "#fff" }}
                >
                  {this.state.isOpen ? (
                    <>
                      <div style={{ width: "35px" }}>
                        <i
                          className={`menu-icon tf-icons fa fa-credit-card`}
                          aria-hidden="true"
                          style={{ fontSize: "22px" }}
                        />
                      </div>
                      <div className="link_text text-start ps-0">Billing</div>
                    </>
                  ) : (
                    <Tooltip
                      title="Billing"
                      classes={{ popper: "custom-tooltip" }}
                    >
                      <i
                        className={`menu-icon tf-icons fa fa-credit-card`}
                        aria-hidden="true"
                        style={{ fontSize: "22px" }}
                      />
                    </Tooltip>
                  )}
                </div>
              </Link>
            )} */}
          </ul>
        </aside>
      </div>
    );
  }
}
const mapStateToProps = (state) => {
  return {
    activeChildMenu: state.activeMenu.activeChildMenu,
  };
};
export default connect(mapStateToProps)(EventSidebar);
